import { render, staticRenderFns } from "./deliverableCardModal.vue?vue&type=template&id=25815e81&scoped=true&lang=html&"
import script from "./deliverableCardModal.vue?vue&type=script&lang=js&"
export * from "./deliverableCardModal.vue?vue&type=script&lang=js&"
import style0 from "./deliverableCardModal.vue?vue&type=style&index=0&id=25815e81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25815e81",
  null
  
)

export default component.exports